import React, {useState} from 'react';
import {Button, Card, Checkbox, Col, DatePicker, Form, Row, Spin} from 'antd';
import dayjs from 'dayjs';

import {grey} from '../../assets/colors';
import {emptyReportCheckBox, formItemFullWidth} from '../../assets/styles';
import {dateFormat} from '../../lib/time';
import {httpGetBlob} from '../../helpers/http';
import {messageType, showMessages} from '../../helpers/message';
import {ReportsCardProps, ReportsErrorType, ReportsFormValues} from '../../types/reportTypes';

const reportsUrl = window.env.BACKEND_API_URL + '/reports';

const ReportsCard = ({
                         cardDescription,
                         cardTitle,
                         emptyReportText,
                         reportName,
                         defaultStartDate,
                         defaultEndDate,
                         disableDatePickers = false,
                         shareClassExists = false,
                     }: ReportsCardProps) => {
    const [loading, setLoading] = useState(false);

    const handleFinish = async ({start_date, end_date, empty_report}: ReportsFormValues) => {
        setLoading(true);

        try {
            const reportUrl = `${reportsUrl}/?name=${reportName.toLowerCase()}&started_at=${formatDate(start_date)}&ended_at=${formatDate(end_date)}&share_class=null&empty_report=${empty_report ? 1 : 0}`;

            const csvBlob = await httpGetBlob(reportUrl);

            // Create blob link to download.
            const downloadUrl = window.URL.createObjectURL(csvBlob);
            const link = document.createElement('a');
            const fileName = `${reportName}_${dayjs().format('YYYY-MM-DD')}.csv`;

            link.href = downloadUrl;
            link.setAttribute('download', fileName);

            // Append to html link element page and trigger download.
            document.body.appendChild(link);
            link.click();

            // Clean up and remove the link.
            link.parentNode?.removeChild(link);
        } catch (error) {
            showMessages((error as ReportsErrorType).message, messageType.error);
        }
        setLoading(false);
    };

    const formatDate = (date: string) => (dayjs(date).format("YYYY-MM-DD"));

    return (
        <Spin spinning={loading}>
            <Card title={cardTitle} bordered={true}>
                <Form
                    name="report-generate"
                    layout="vertical"
                    onFinish={handleFinish}
                    initialValues={{
                        start_date: defaultStartDate,
                        end_date: defaultEndDate,
                    }}
                >
                    <Form.Item>
                        <Card.Meta
                            description={<span style={{color: grey}}>{cardDescription}</span>}
                        />
                    </Form.Item>
                    <Form.Item name="start_date" label="Start Date" style={{marginTop: "2rem"}}>
                        <DatePicker
                            placeholder="DD MM YYYY"
                            format={dateFormat}
                            style={{...formItemFullWidth}}
                            disabled={disableDatePickers}
                        />
                    </Form.Item>
                    <Form.Item name="end_date" label="End Date" style={{marginTop: "2rem"}}>
                        <DatePicker
                            placeholder="DD MM YYYY"
                            format={dateFormat}
                            style={{...formItemFullWidth}}
                            disabled={disableDatePickers}
                        />
                    </Form.Item>
                    {emptyReportText && (
                        <Form.Item name="empty_report" valuePropName="checked">
                            <Row style={{...emptyReportCheckBox}}>
                                <Checkbox> </Checkbox>
                                {emptyReportText}
                            </Row>
                        </Form.Item>
                    )}
                    {/*{shareClassExists && (*/}
                    {/*    <Form.Item name="share_class">*/}
                    {/*        <Row>*/}
                    {/*            <Col span={12}>*/}
                    {/*                <Input maxLength={20} placeholder="Share Class" disabled={true}/>*/}
                    {/*                <Tooltip*/}
                    {/*                    placement="right"*/}
                    {/*                    title="Share classes are not yet implemented. Leave empty to generate a report of all share balances from people and companies."*/}
                    {/*                >*/}
                    {/*                    <InfoCircleOutlined style={{marginTop: "10px"}}/>*/}
                    {/*                </Tooltip>*/}
                    {/*            </Col>*/}
                    {/*        </Row>*/}
                    {/*    </Form.Item>*/}
                    {/*)}*/}
                    <Form.Item>
                        <Row justify="end">
                            <Col>
                                <Button type="primary" htmlType="submit" loading={loading}>
                                    Generate
                                </Button>
                            </Col>
                        </Row>
                    </Form.Item>
                </Form>
            </Card>
        </Spin>
    );
};

export default ReportsCard;
